import Head from 'next/head'

import Icon from './front-end/Icons/Icon'
import data from './front-end/Icons/icon-data'

const title = 'Content animated + on scroll'
const icons = data[title]
const AnimatedIconsGuide = (): JSX.Element => (
  <div className="relative py-12">
    <div className="container mx-auto flex flex-col gap-y-[60vh] px-5">
      <Head>
        <title>Animated Icons</title>
      </Head>
      <h1 className="h3">Animated Icon SVG font library</h1>
      <a href="#icons" className="h6 flex items-center gap-1">
        (<span className="underline">Scroll down</span> <Icon name="arrow-south" type="stroke" />)
      </a>
      <div id="icons" className="space-y-6 pt-8 last:mb-12">
        <h3 className="h4">{title}</h3>
        <div className="grid auto-rows-auto grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-x-4 gap-y-5 whitespace-nowrap text-[12px]">
          {icons.map((props, iconIndex) => (
            <span className="flex w-fit items-center gap-2" key={`${props.name}-${props.type ?? 'fill'}-${iconIndex}`}>
              <span className="shrink-0">
                <Icon {...props} />
              </span>
              <span className="relative">{props.name}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
)

export default AnimatedIconsGuide
